import React from 'react';

import { Button } from 'shared/components/Button/Button';
import { FoldersIcon } from 'shared/components/icons/FoldersIcon';
import { ArrowUpRightFromSquare } from 'shared/components/icons/ArrowUpRightFromSquare';
import { Link } from 'react-router-dom';
import {
  AgreementDetailsSection,
  AgreementTpvPreviewSection,
  FlexContainer,
  FlexRow,
  Label,
  SystemSection,
  Title,
  Value,
} from './AgreementsAccordion.styles';
import { Section } from './Section';
import { AgreementPreviewLink } from '../../../../../api/types';

type Props = {
  overviewList: { label: string; value: string | undefined }[];
  contractDetailsList: { label: string; value: string | undefined }[];
  financialsList: { label: string; value: string | undefined }[];
  systemList: { label: string; value: string | undefined }[];
  tpvPreviewLinks: AgreementPreviewLink[];
  isArchived: boolean;
  grafanaLink: string | null;
  monitoringVendorLink: string | null;
  onToggleArchive: () => void;
  onFetchPreviewVideoLinks: () => void;
};
export function AgreementSection({
  overviewList,
  contractDetailsList,
  financialsList,
  systemList,
  tpvPreviewLinks,
  isArchived,
  grafanaLink,
  monitoringVendorLink,
  onToggleArchive,
  onFetchPreviewVideoLinks,
}: Props) {
  const handleGrafanaClick = () => {
    if (grafanaLink) {
      window.open(grafanaLink, '_blank');
    }
  };
  const handleVendorPortalClick = () => {
    if (monitoringVendorLink) {
      window.open(monitoringVendorLink, '_blank');
    }
  };

  return (
    <FlexContainer>
      <AgreementDetailsSection>
        <Section title="Overview" items={overviewList} />
        <Section title="Contract Details" items={contractDetailsList} />
        <Section title="Financials" items={financialsList} />
      </AgreementDetailsSection>

      <SystemSection>
        <Title as="h3">System</Title>
        <AgreementDetailsSection>
          {systemList.map((item) => (
            <div key={item.label}>
              <Label as="p">{item.label}</Label>
              <Value as="p">{item.value}</Value>
            </div>
          ))}
        </AgreementDetailsSection>

        <Title as="h5">Monitoring Links</Title>
        {grafanaLink && (
          <Button
            label="View in Watchmen Grafana"
            styleVariant="tertiary"
            Icon={ArrowUpRightFromSquare}
            iconRight
            onClick={handleGrafanaClick}
          />
        )}
        {monitoringVendorLink && (
          <Button
            label="View in Vendor Portal"
            styleVariant="tertiary"
            Icon={ArrowUpRightFromSquare}
            iconRight
            onClick={handleVendorPortalClick}
          />
        )}
      </SystemSection>

      <AgreementTpvPreviewSection>
        <FlexRow>
          <Title as="h5">Third Party Verification</Title>
          <Button
            label="Preview Result"
            styleVariant="tertiary"
            onClick={onFetchPreviewVideoLinks}
          />
        </FlexRow>
        {tpvPreviewLinks.length > 0 && (
          <ul>
            {tpvPreviewLinks.map((link) => (
              <li>
                <Link target="_blank" to={link.video_url}>
                  Video {link.confirmation_code}
                </Link>
                {link.transcript_url && (
                  <>
                    <span> - </span>
                    <Link target="_blank" to={link.transcript_url}>
                      Transcript {link.confirmation_code}
                    </Link>
                  </>
                )}
              </li>
            ))}
          </ul>
        )}
      </AgreementTpvPreviewSection>

      <Button
        label={`${isArchived ? 'Unarchive' : 'Archive'} Agreement`}
        styleVariant="tertiary"
        Icon={FoldersIcon}
        onClick={onToggleArchive}
      />
    </FlexContainer>
  );
}

export default AgreementSection;
